import { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import devolucionesService from '../../api/devolucionesService'
import type { CoberturaTrasladosData } from '../../types/devoluciones'
import { extractAxiosApiErrorMessage } from '../../utils/apiErrorMessage'

export function useCoberturaTraslados(orderId?: number | string | null) {
  const [cobertura, setCobertura] = useState<CoberturaTrasladosData | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchCobertura = useCallback(async (id: number | string) => {
    setIsLoading(true)
    setError(null)
    try {
      const response = await devolucionesService.getCoberturaTraslados(id)
      if (!response?.data) {
        const message = 'No se pudo obtener la cobertura de transferencias. Verifique las conexiones.'
        setError(message)
        setCobertura(null)
        toast.error(message)
        return null
      }
      setCobertura(response.data)
      return response.data
    } catch (err) {
      const message = extractAxiosApiErrorMessage(
        err,
        'Error al consultar cobertura de transferencias. Verifique las conexiones.'
      )
      setError(message)
      setCobertura(null)
      toast.error(message)
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (orderId == null || orderId === '') {
      setCobertura(null)
      setError(null)
      return
    }
    fetchCobertura(orderId)
  }, [fetchCobertura, orderId])

  return {
    cobertura,
    isLoading,
    error,
    refetch: fetchCobertura
  }
}
